import React, { useState, useEffect } from "react";
import TopHeading from "../Heading/TopHeading";
import { Form, Button, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import axios from "../../axios";
import { Loader } from "../UI";

export default function SingleChildContent() {
  const authToken = localStorage.getItem("access_token");
  const params = useParams();
  const [childData, setChildData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const genderOpts = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];
  const schoolYearOpts = [
    { value: "1", label: "Year 1" },
    { value: "2", label: "Year 2" },
    { value: "3", label: "Year 3" },
    { value: "4", label: "Year 4" },
    { value: "5", label: "Year 5" },
    { value: "6", label: "Year 6" },
    { value: "7", label: "Year 7" },
    { value: "8", label: "Year 8" },
    { value: "9", label: "Year 9" },
    { value: "10", label: "Year 10" },
    { value: "11", label: "Year 11" },
  ];
  const mealBenefitOpts = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];
  const statusOpts = [
    { value: "pending", label: "Pending" },
    { value: "registered", label: "Registered" },
  ];

  const selectedGender = genderOpts.find(
    (obj) => obj.value === childData.gender
  );
  const selectedYear = schoolYearOpts.find(
    (obj) => obj.value === childData.schoolYear
  );
  const selectedBenefit = mealBenefitOpts.find(
    (obj) => obj.value === childData.mealBenefit
  );
  const selectedStatus = statusOpts.find(
    (obj) => obj.value === childData.status
  );

  const [readMode, setReadMode] = useState(true);
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    dob: Yup.date().required("Required"),
    gender: Yup.string().required("Required"),
    school: Yup.string().required("Required"),
    schoolYear: Yup.string().required("Required"),
    mealBenefit: Yup.string().required("Required"),
    status: Yup.string().required("Required"),
    allergies: Yup.boolean(),
    allergiesText: Yup.string().when("allergies", {
      is: true,
      then: Yup.string().required("Required").nullable(true),
      otherwise: Yup.string().notRequired().nullable(true),
    }),
    special: Yup.boolean(),
    specialText: Yup.string().when("special", {
      is: true,
      then: Yup.string().required("Required").nullable(true),
      otherwise: Yup.string().notRequired().nullable(true),
    }),
    inhaler: Yup.boolean(),
    inhalerText: Yup.string().when("inhaler", {
      is: true,
      then: Yup.string().required("Required").nullable(true),
      otherwise: Yup.string().notRequired().nullable(true),
    }),
    dislikes: Yup.boolean(),
    dislikesText: Yup.string().when("dislikes", {
      is: true,
      then: Yup.string().required("Required").nullable(true),
      otherwise: Yup.string().notRequired().nullable(true),
    }),
    favourites: Yup.boolean(),
    favouritesText: Yup.string().when("favourites", {
      is: true,
      then: Yup.string().required("Required").nullable(true),
      otherwise: Yup.string().notRequired().nullable(true),
    }),
  });

  const handleEdit = (e) => {
    e.preventDefault();
    setReadMode(false);
  };

  const fetchChild = () => {
    axios
      .get(`/children/${params.childId}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data) {
          setChildData(response.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        toast.error("Couldn't load child");
        setIsLoading(false);
      });
  };

  const handleUpdate = (values, setSubmitting) => {
    axios
      .put(`/children/${params.childId}`, values, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data) {
          if (response.status === 200) {
            toast.success(response.data.message);
          } else {
            toast.warn("No response from server");
          }
        }
        setSubmitting(false);
        setReadMode(true);
      })
      .catch((error) => {
        toast.error("Couldn't update child");
        setSubmitting(false);
        setReadMode(true);
      });
  };

  useEffect(() => {
    fetchChild();
  }, []);

  return (
    <div className="single-child-content">
      <TopHeading title="Child" />
      <div className="single-child light-bg corner-radius p-4 mb-3">
        {isLoading ? (
          <Loader />
        ) : (
          <Formik
            initialValues={childData}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) =>
              handleUpdate(values, setSubmitting)
            }
          >
            {({
              values,
              setFieldValue,
              handleChange,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit}>
                <div className="row g-0">
                  <div className="col-md-6 pe-md-2">
                    <Form.Group className="mb-3">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="firstName"
                        placeholder="Enter first name"
                        value={values.firstName}
                        onChange={handleChange}
                        disabled={readMode || isSubmitting}
                      />
                      <ErrorMessage
                        name="firstName"
                        component="p"
                        className="error-message"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6 ps-md-2">
                    <Form.Group className="mb-3">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="lastName"
                        placeholder="Enter last name"
                        value={values.lastName}
                        onChange={handleChange}
                        disabled={readMode || isSubmitting}
                      />
                      <ErrorMessage
                        name="lastName"
                        component="p"
                        className="error-message"
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row g-0">
                  <div className="col-md-6 pe-md-2">
                    <Form.Group className="mb-3">
                      <Form.Label>Date of Birth</Form.Label>
                      <Form.Control
                        type="date"
                        name="dob"
                        value={values.dob}
                        onChange={handleChange}
                        disabled={readMode || isSubmitting}
                      />
                      <ErrorMessage
                        name="dob"
                        component="p"
                        className="error-message"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6 ps-md-2">
                    <Form.Group className="mb-3">
                      <Form.Label>Gender</Form.Label>
                      <Select
                        name="gender"
                        options={genderOpts}
                        isSearchable={false}
                        isClearable={false}
                        defaultValue={selectedGender ? selectedGender : null}
                        onChange={(opt) => setFieldValue("gender", opt.value)}
                        isDisabled={readMode || isSubmitting}
                      />
                      <ErrorMessage
                        name="gender"
                        component="p"
                        className="error-message"
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row g-0">
                  <div className="col-md-6 pe-md-2">
                    <Form.Group className="mb-3">
                      <Form.Label>School Attending</Form.Label>
                      <Form.Control
                        type="text"
                        name="school"
                        placeholder="Enter school name"
                        value={values.school}
                        onChange={handleChange}
                        disabled={readMode || isSubmitting}
                      />
                      <ErrorMessage
                        name="school"
                        component="p"
                        className="error-message"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6 ps-md-2">
                    <Form.Group className="mb-3">
                      <Form.Label>Year in School</Form.Label>
                      <Select
                        name="schoolYear"
                        options={schoolYearOpts}
                        isSearchable={false}
                        isClearable={false}
                        defaultValue={selectedYear ? selectedYear : null}
                        onChange={(opt) =>
                          setFieldValue("schoolYear", opt.value)
                        }
                        isDisabled={readMode || isSubmitting}
                      />
                      <ErrorMessage
                        name="schoolYear"
                        component="p"
                        className="error-message"
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row g-0">
                  <div className="col-md-6 pe-md-2">
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Does the child get benefit related free school meals?
                      </Form.Label>
                      <Select
                        name="mealBenefit"
                        options={mealBenefitOpts}
                        isSearchable={false}
                        isClearable={false}
                        defaultValue={selectedBenefit ? selectedBenefit : null}
                        onChange={(opt) =>
                          setFieldValue("mealBenefit", opt.value)
                        }
                        isDisabled={readMode || isSubmitting}
                      />
                      <ErrorMessage
                        name="mealBenefit"
                        component="p"
                        className="error-message"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6 ps-md-2">
                    <Form.Group className="mb-3">
                      <Form.Label>Status</Form.Label>
                      <Select
                        name="status"
                        options={statusOpts}
                        isSearchable={false}
                        isClearable={false}
                        defaultValue={selectedStatus ? selectedStatus : null}
                        onChange={(opt) => setFieldValue("status", opt.value)}
                        isDisabled={readMode || isSubmitting}
                      />
                      <ErrorMessage
                        name="status"
                        component="p"
                        className="error-message"
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row g-0">
                  <div className="col-md-12">
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Does your child/children have any allergies, chronic
                        illness, or medical conditions? If yes, please describe.
                      </Form.Label>
                      <div className="d-flex">
                        <Form.Check
                          type="radio"
                          name="allergies"
                          id="allergies-yes"
                          label="Yes"
                          className="me-3"
                          onChange={(e) => {
                            e.target.checked &&
                              setFieldValue("allergies", true);
                          }}
                          defaultChecked={values.allergies}
                          disabled={readMode || isSubmitting}
                        />
                        <Form.Check
                          type="radio"
                          name="allergies"
                          id="allergies-no"
                          label="No"
                          onChange={(e) => {
                            e.target.checked &&
                              setFieldValue("allergies", false);
                          }}
                          defaultChecked={!values.allergies}
                          disabled={readMode || isSubmitting}
                        />
                      </div>
                      {values.allergies != 0 && (
                        <Form.Control
                          as="textarea"
                          name="allergiesText"
                          rows={3}
                          placeholder="Please Describe"
                          className="mt-2"
                          value={values.allergiesText}
                          onChange={handleChange}
                          disabled={readMode || isSubmitting}
                        />
                      )}
                      <ErrorMessage
                        name="allergiesText"
                        component="p"
                        className="error-message"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Does your Child have Special Education Needs (SEN)? If
                        yes, please specify.
                      </Form.Label>
                      <div className="d-flex">
                        <Form.Check
                          type="radio"
                          name="special"
                          id="special-yes"
                          label="Yes"
                          className="me-3"
                          onChange={(e) => {
                            e.target.checked && setFieldValue("special", true);
                          }}
                          defaultChecked={values.special}
                          disabled={readMode || isSubmitting}
                        />
                        <Form.Check
                          type="radio"
                          name="special"
                          id="special-no"
                          label="No"
                          onChange={(e) => {
                            e.target.checked && setFieldValue("special", false);
                          }}
                          defaultChecked={!values.special}
                          disabled={readMode || isSubmitting}
                        />
                      </div>
                      {values.special != 0 && (
                        <Form.Control
                          as="textarea"
                          name="specialText"
                          rows={3}
                          placeholder="Please Describe"
                          className="mt-2"
                          value={values.specialText}
                          onChange={handleChange}
                          disabled={readMode || isSubmitting}
                        />
                      )}
                      <ErrorMessage
                        name="specialText"
                        component="p"
                        className="error-message"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Is the Child prescribed any medication / inhaler? If
                        yes, please explain any instructions.
                      </Form.Label>
                      <div className="d-flex">
                        <Form.Check
                          type="radio"
                          name="inhaler"
                          id="inhaler-yes"
                          label="Yes"
                          className="me-3"
                          onChange={(e) => {
                            e.target.checked && setFieldValue("inhaler", true);
                          }}
                          defaultChecked={values.inhaler}
                          disabled={readMode || isSubmitting}
                        />
                        <Form.Check
                          type="radio"
                          name="inhaler"
                          id="inhaler-no"
                          label="No"
                          onChange={(e) => {
                            e.target.checked && setFieldValue("inhaler", false);
                          }}
                          defaultChecked={!values.inhaler}
                          disabled={readMode || isSubmitting}
                        />
                      </div>
                      {values.inhaler != 0 && (
                        <Form.Control
                          as="textarea"
                          name="inhalerText"
                          rows={3}
                          placeholder="Please Describe"
                          className="mt-2"
                          value={values.inhalerText}
                          onChange={handleChange}
                          disabled={readMode || isSubmitting}
                        />
                      )}
                      <ErrorMessage
                        name="inhalerText"
                        component="p"
                        className="error-message"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Is there anything your child don't like (food, games
                        etc) or is scared of?
                      </Form.Label>
                      <div className="d-flex">
                        <Form.Check
                          type="radio"
                          name="dislikes"
                          id="dislikes-yes"
                          label="Yes"
                          className="me-3"
                          onChange={(e) => {
                            e.target.checked && setFieldValue("dislikes", true);
                          }}
                          defaultChecked={values.dislikes}
                          disabled={readMode || isSubmitting}
                        />
                        <Form.Check
                          type="radio"
                          name="dislikes"
                          id="dislikes-no"
                          label="No"
                          onChange={(e) => {
                            e.target.checked &&
                              setFieldValue("dislikes", false);
                          }}
                          defaultChecked={!values.dislikes}
                          disabled={readMode || isSubmitting}
                        />
                      </div>
                      {values.dislikes != 0 && (
                        <Form.Control
                          as="textarea"
                          name="dislikesText"
                          rows={3}
                          placeholder="Please Describe"
                          className="mt-2"
                          value={values.dislikesText}
                          onChange={handleChange}
                          disabled={readMode || isSubmitting}
                        />
                      )}
                      <ErrorMessage
                        name="dislikesText"
                        component="p"
                        className="error-message"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        What are your child's favourite Sports / Games /
                        Activities?
                      </Form.Label>
                      <div className="d-flex">
                        <Form.Check
                          type="radio"
                          name="favourites"
                          id="favourites-yes"
                          label="Yes"
                          className="me-3"
                          onChange={(e) => {
                            e.target.checked &&
                              setFieldValue("favourites", true);
                          }}
                          defaultChecked={values.favourites}
                          disabled={readMode || isSubmitting}
                        />
                        <Form.Check
                          type="radio"
                          name="favourites"
                          id="favourites-no"
                          label="No"
                          onChange={(e) => {
                            e.target.checked &&
                              setFieldValue("favourites", false);
                          }}
                          defaultChecked={!values.favourites}
                          disabled={readMode || isSubmitting}
                        />
                      </div>
                      {values.favourites != 0 && (
                        <Form.Control
                          as="textarea"
                          name="favouritesText"
                          rows={3}
                          placeholder="Please Describe"
                          className="mt-2"
                          value={values.favouritesText}
                          onChange={handleChange}
                          disabled={readMode || isSubmitting}
                        />
                      )}
                      <ErrorMessage
                        name="favouritesText"
                        component="p"
                        className="error-message"
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  {readMode ? (
                    <>
                      <Button
                        variant="secondary"
                        type="button"
                        size="sm"
                        className="me-2"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </Button>
                      <Button
                        variant="primary"
                        type="button"
                        size="sm"
                        onClick={handleEdit}
                      >
                        Edit
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="secondary"
                        type="button"
                        size="sm"
                        className="me-2"
                        onClick={() => navigate(-1)}
                        disabled={isSubmitting}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="primary"
                        type="submit"
                        size="sm"
                        disabled={isSubmitting}
                      >
                        Update
                        {isSubmitting && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="ms-2"
                          />
                        )}
                      </Button>
                    </>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        )}
      </div>
    </div>
  );
}
